module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppSteppers', {
    staticClass: "px-2 py-2",
    attrs: {
      "start-step-name": "Данные пользователя"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var prevStep = ref.prevStep;
        var nextStep = ref.nextStep;

        return [_c('AppSteppersPane', {
          attrs: {
            "step-name": "Данные пользователя"
          }
        }, [_c('DynamicAdditionalDataForm', {
          attrs: {
            "next-step": nextStep
          }
        })], 1), _c('AppSteppersPane', {
          attrs: {
            "step-name": "Отклик на вакансию"
          }
        }, [_c('VacancyRespondForm', {
          attrs: {
            "isError": _vm.isError,
            "isLoading": _vm.isLoading,
            "isMessage": _vm.isMessage,
            "errorMessage": _vm.errorMessage
          },
          on: {
            "understood": _vm.closeForm,
            "cancelRespond": _vm.closeForm,
            "submitRespond": function (data) { return _vm.submitRespond(nextStep, data); }
          }
        })], 1), _c('AppSteppersPane', {
          attrs: {
            "step-name": "Статус"
          }
        }, [_c('FinishMessage', {
          attrs: {
            "message": _vm.message
          },
          on: {
            "understood": _vm.closeForm
          }
        })], 1)]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66d87af5","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ordersProcessForms/vacancy/VacancyRespondFormModalBody.vue
// module id = a56e3943d52138c42ed2
// module chunks = 13